import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../actions/login.action";
import Button from "../button";
import "../../containers/login/styles.css";

export default function SessionHardCapExpired() {
  const storeDispatch = useDispatch();
  const loggedOutRef = useRef(false);

  const doLogout = useCallback(() => {
    if (loggedOutRef.current) return;
    loggedOutRef.current = true;
    logout(storeDispatch);
  }, [storeDispatch]);

  useEffect(() => {
    doLogout();
  }, [doLogout]);

  return (
    <div className="auth-wrapper">
      <div className="auth-card text-center">
        <h3>Session expired</h3>
        <p className="mt-3">
          Your session has reached its maximum duration. Please log in again to
          continue.
        </p>
        <Button variant="primary" size="md" onClick={doLogout}>
          Go to login
        </Button>
      </div>
    </div>
  );
}
